export default __webpack_public_path__ + "static/media/property_manager.d790482e.png";